// Sentry error tracking + performance for the React app.
//
// Config-gated on REACT_APP_SENTRY_DSN: a complete no-op when unset, so local
// dev runs unaffected. Import this once (in index.js) before rendering.
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Noise from browser extensions injecting content scripts into the page
    // (commonly password managers / autofill on Windows Chrome). These reject
    // a promise that bubbles to the global onunhandledrejection handler; they
    // originate from extension code, not ours, and aren't actionable.
    ignoreErrors: [
      'Object Not Found Matching Id',
      // Generic ResizeObserver chatter, also non-actionable.
      'ResizeObserver loop completed with undelivered notifications',
      'ResizeObserver loop limit exceeded',
    ],
    // Performance tracing sample rate (0–1).
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    // Session Replay: sample a small % of sessions, all sessions with an error.
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export default Sentry;
